<template>
    <div class="p-3 h-100 m-3">
        <b-row>

            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">Nome</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.nome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">Cognome</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.cognome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">Identificativo</label>
                <b-form-input :disabled="true" class="w-100 text-upper"
                    v-model="jsonData.identificativo"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">Data Compilazione</label>
                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"
                    v-model="jsonData.dataCompilazione"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-ft-label">Comune Nascita</label>
                <b-form-input :disabled="true" id="inline-form-custom-select-pref" v-model="jsonData.comune"
                    class="mb-2 mr-sm-2 mb-sm-0">
                </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-ft-label">Data Nascita</label>
                <date-picker :disabled="true" format="DD-MM-YYYY" value-type="timestamp" type="date"
                    v-model="jsonData.dataNascita"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-ft-label">Eta'</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.eta"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-ft-label">Sesso</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.sesso"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Residenza</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.residenza"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Domicilio</label>
                <b-form-input :disabled="true" class="w-100 text-upper" v-model="jsonData.domicilio"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-ft-label">Tipo Trattamento</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipoTrattamento"
                    class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="descrizione"
                    :options="tipoTrattamentoOptions">
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-ft-label">Provenienza</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.provenienza"
                    class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="descrizione"
                    :options="provenienzaOptions">
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Diagnosi in Ingresso</label>
                <b-form-textarea v-model="jsonData.diagnosiIngresso" rows="2"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Cenni Anamnestici</label>
                <b-form-textarea v-model="jsonData.cenniAnamnestici" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Valutazione Fisiatrica</label>
                <b-form-textarea v-model="jsonData.valutazioneFisiatrica" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Valutazione Neuropsichiatrica</label>
                <b-form-textarea v-model="jsonData.valutazioneNeuropsichiatrica" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Progetto Riabilitativo</label>
                <b-form-textarea v-model="jsonData.progettoRiabilitativo" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Programmi Riabilitativi - Area Riabilitativa</label>
                <b-form-textarea v-model="jsonData.programmiRiabilitativi" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-ft-label">Figure Professionali</label>
                <b-row>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch v-model="jsonData.fisioterapista">
                                        Fisioterapista
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.fisioterapista"
                                        v-model="jsonData.fisioterapistaText" class="form-control"
                                        placeholder="fisioterapista"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch v-model="jsonData.logopedista">
                                        Logopedista
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.logopedista"
                                        v-model="jsonData.logopedistaText" class="form-control"
                                        placeholder="logopedista"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch v-model="jsonData.neuro">
                                        Neuropsicomotricista dell'eta' evolutiva
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.neuro"
                                        v-model="jsonData.neuroText" class="form-control"
                                        placeholder="neuropsicomotricista"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch v-model="jsonData.assistenteSociale">
                                        Assistente Sociale
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.assistenteSociale"
                                        v-model="jsonData.assistenteSocialeText" class="form-control"
                                        placeholder="assistente sociale"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch v-model="jsonData.psicologo">
                                        Psicologo
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.psicologo"
                                        v-model="jsonData.psicologoText" class="form-control"
                                        placeholder="psicologo"></b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="card p-3 mb-3 shadow-sm">
                            <b-row>
                                <b-col cols="4" style="align-content: center;">
                                    <b-form-checkbox switch v-model="jsonData.terapista">
                                        Terapista Occupazionale
                                    </b-form-checkbox></b-col>
                                <b-col cols="8"> <input type="text" :disabled="!jsonData.terapista"
                                        v-model="jsonData.terapistaText" class="form-control"
                                        placeholder="terapista occupazionale"></b-col>
                            </b-row>
                        </div>
                    </b-col>

                </b-row>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">ID PRI</label>
                <b-form-input class="w-100 text-upper" v-model="jsonData.idPri"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">Data e ora inizio</label>
                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"
                    v-model="jsonData.dataOraInizio"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-ft-label">Data e ora fine</label>
                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"
                    v-model="jsonData.dataOraFine"></date-picker>
            </b-col>

        </b-row>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
    components: { DatePicker },
    data() {
        return {
            jsonData: {
                nome: null,
                cognome: null,
                identificativo: null,
                dataCompilazione: null,
                comune: null,
                dataNascita: null,
                eta: '',
                sesso: '',
                residenza: '',
                domicilio: '',
                tipoTrattamento: null,
                provenienza: null,
                diagnosiIngresso: '',
                cenniAnamnestici: '',
                valutazioneFisiatrica: '',
                valutazioneNeuropsichiatrica: '',
                progettoRiabilitativo: '',
                programmiRiabilitativi: '',
                fisioterapista: false,
                fisioterapistaText: '',
                logopedista: false,
                logopedistaText: '',
                neuro: false,
                neuroText: '',
                assistenteSociale: false,
                assistenteSocialeText: '',
                psicologo: false,
                psicologoText: '',
                terapista: false,
                terapistaText: '',

                dataOraInizio: null,
                dataOraFine: null
            },
            pathResourceAcc: "/accettazioni",
            pathResource: "/progettoriabilitativoindividuale",
            comuniOptions: [],
            tipoTrattamentoOptions: [],
            provenienzaOptions: []

        }
    },
    methods: {
        init(jsonData) {
            this.jsonData.dataCompilazione = new Date().getTime();
            this.setDatiAnagraficiPri(jsonData);
        },
        setDatiAnagraficiPri(jsonData) {
            let anagrafica = jsonData.accettazioneAnagrafica;
            this.jsonData.idAccettazione = jsonData.id;
            this.jsonData.cognome = anagrafica.cognome;
            this.jsonData.nome = anagrafica.nome;
            this.jsonData.identificativo = anagrafica.identificativo;
            this.jsonData.comune = anagrafica.comuneNascita;
            this.jsonData.dataNascita = anagrafica.dataNascita;
            this.jsonData.sesso = anagrafica.sesso;
            this.jsonData.residenza = anagrafica.indirizzoResidenza + " , " + anagrafica.capResidenza + " , " + anagrafica.comuneResidenza + " , " + anagrafica.provinciaResidenza;
            this.jsonData.domicilio = anagrafica.indirizzoDomicilio + " , " + anagrafica.capDomicilio + " , " + anagrafica.comuneDomicilio + " , " + anagrafica.provinciaDomicilio;
            this.jsonData.eta = this.calcolaEta(anagrafica.dataNascita);
        },

        setViewPri(pri, jsonData) {
            this.setDatiAnagraficiPri(jsonData);
            this.jsonData = { ...this.jsonData, ...pri };
        },

        calcolaEta(timestampNascita) {
            const oggi = new Date();
            const dataNascita = new Date(timestampNascita);
            let eta = oggi.getFullYear() - dataNascita.getFullYear();
            const mese = oggi.getMonth() - dataNascita.getMonth();
            const giorno = oggi.getDate() - dataNascita.getDate();
            if (mese < 0 || (mese === 0 && giorno < 0)) {
                eta--;
            }
            return eta;
        },

        getJsonData() {

            return this.jsonData;
        }

    }
}
</script>

<style lang="scss" scoped></style>